import { FiChevronRight } from "react-icons/fi";
import styled from "styled-components/macro";
import { Link, Card, Text } from "../../../../components";

export const CardIcon = styled(FiChevronRight)`
  font-size: 2rem;
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const BodyLabelLink = styled(Text)`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  margin-bottom: 4px;
`;

export const NavigationLinkItemStyled = styled(Link)`
  width: 100%;
  height: 100%;
  text-decoration: none !important;
`;

export const NavigationCardItemStyled = styled(Card)`
  & .Card__Body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .Card__Body > div {
    width: 100%;
    max-width: 90%;
  }
`;
